export default "__VITE_ASSET__56d9d315__"